<template>
  <div class="mt-4" >
    <div>
      <label for="user_ltd_code" class="label" v-if="numberOfCodes > 1">Lifetime deal codes</label>
      <label for="user_ltd_code" class="label" v-else>Lifetime deal code</label>
      <input
        v-for="(c,index) in numberOfCodes"
        :key="index"
        autocomplete="off"
        v-model="code[index]"
        type="text"
        :id="'user_stack_code'+code"
        class="input mb-1"
        @change="newCode"
      >
      <!-- <span class="btn-flat flex flex-row justify-end" >
        <div class="add_more flex items-center" @click="addField">
          <div>
            <svg class="w-5 h-5"  fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
          </div>
          <div>
            <span class="ml-2 text-neutral-800 whitespace-nowrap">Add more</span>
          </div>
        </div>
      </span> -->
      <input
        type="hidden"
        name="user[stack_codes]"
        :value="codes"
      >
    </div>
  </div>
</template>

<script>
import index from '../changelog/labels/index.vue';
export default {
  props: ["stack-codes", "number-of-codes"],
  components: { index },
  name:"multiple_codes",
  data() {
    return {
      code: {},
      codes: []
    };
  },
  created(){
    this.stackCodes.split(',').forEach((code, index) => {
      let obj = {}
      obj[index] = code;
      this.getCodes = obj;
    })

  },
  computed: {
    getCodes: {
      get(){
        return this.code;
      },
      set(val){
        this.code = Object.assign(this.code, val)
      }
    }
  },
  methods:{
    newCode($event) {
      this.codes = Object.values(this.code)
      this.codes = this.codes.filter((c) => c != '')
    },
    remove(index) {
      this.codes.splice(index, 1)
    },
    addField() {
      this.numberOfCodes +=1
    }
  }
};
</script>

<style scoped>
.add_more{
  width:100px;
}
</style>
